import {useAtomValue} from 'jotai';
import {memo, useEffect, useState} from 'react';
import {HomeElderlyWelfareData, MarkersLayerProps} from '@/map/@types';
import {useNearbyHomeElderlyWelfare} from '@/map/api';
import {nearbyInfoAtom} from '@/map/atom';
import {MARKER_COUNT_LIMIT} from '@/map/constants';
import {AreaAnalyticsFilter} from '@/map/enums';
import {convertToCoordFromPointCoords, getOverlapedMarkers} from '@/map/utils';
import {HomeElderlyWelfareMarker} from '../../Markers';

const getList = (data?: HomeElderlyWelfareData[]) => {
  const draft: HomeElderlyWelfareData[] = [];

  if (!data) {
    return draft;
  }

  data.forEach((i: HomeElderlyWelfareData) => {
    const coords = i?.location?.coordinates;

    if (coords) {
      if (!i.position) {
        const point = convertToCoordFromPointCoords(coords);

        if (point) {
          i.position = point;
        }
      }

      const index = draft.findIndex(
        (j) => i.name === j.name && (i.position as any).equals(j.position)
      );

      if (index === -1) {
        draft.push(i);
      }
    }
  });

  return getOverlapedMarkers(draft);
};

export const HomeElderlyWelfareLayer = memo(
  ({map, bounds}: MarkersLayerProps) => {
    const {selected} = useAtomValue(nearbyInfoAtom);
    const isActive = selected.includes(
      AreaAnalyticsFilter.HOME_ELDERLY_WELFARE
    );

    const {data} = useNearbyHomeElderlyWelfare(
      isActive && bounds
        ? {
            limit: MARKER_COUNT_LIMIT * 2,
            ...bounds,
          }
        : undefined
    );

    const [list, setList] = useState<HomeElderlyWelfareData[]>([]);

    useEffect(() => {
      if (data?.length) {
        setList((prev) => {
          return getList([
            ...prev.filter(
              (i) => i.position && map.getBounds().hasPoint(i.position)
            ),
            ...data.slice(0, MARKER_COUNT_LIMIT * 2),
          ]);
        });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    if (!isActive || !list?.length) {
      return null;
    }

    return (
      <>
        {list.map(
          (i, idx) =>
            !!i.position && (
              <HomeElderlyWelfareMarker
                key={idx + i.name + i.position.toString()}
                map={map}
                position={i.position}
                item={i}
              />
            )
        )}
      </>
    );
  }
);
